export interface JobCraft {
  jobCraftID: number;
  jobID: string;
  name: string;
}
